<template>
    <div class="framebody" v-if="profile.id">
        <global-header />

        <!-- 主体 -->
        <white-space />

        <div class="framemain w">
            <div class="left">
                <global-left />
            </div>

            <div class="right">
                <router-view></router-view>
            </div>
        </div>

        <global-footer />
    </div>
</template>

<script>
    import { ContentLoader } from "vue-content-loader";

    export default {
        data() {
            return {
                orderProfile: {},
            };
        },
        computed: {
            profile() {
                return this.$store.state.profile;
            },
            customerService() {
                return this.$store.state.customerService;
            },
        },
        created() {
            // if (!this.$store.state.profile.id) {
            //     this.$loading({ text: "加载中..." });
            // }
        },
        //方法
        methods: {
            loadTStat() {
                this.$http.get("personal/transaction_stat").then((response) => {
                    if (response.success) {
                        this.orderProfile = response.data;
                    }
                });
            },
        },
        //配置组件(对象的简写方式)
        components: {
            ContentLoader,
        },
        created() {},
        mounted() {},
    };
</script>

<style scoped lang="less">
    .framebody {
        .framemain {
            display: flex;
            margin-bottom: 48px;
            .left {
                width: 200px;
            }
            .right {
                width: 0;
                flex: 1;
            }
        }
    }
</style>
